export default __webpack_public_path__ + "static/media/muffins.248be882.png";